import { JSONContent } from '@tiptap/core'
import GithubSlugger from 'github-slugger'

export type Node = JSONContent
export const flattenTipTapNodes = (nodes: Node[]) => {
  const flattened: Node[] = []

  nodes.forEach((node: Node) => {
    if (node.content) {
      const { content, ...rest } = node
      flattened.push(rest as Node)
      flattened.push(...flattenTipTapNodes(content as Node[]))
    } else {
      flattened.push(node)
    }
  })

  return flattened
}

export const recursivelyProcessTipTapNodes = <
  Callback extends (
    node: Node
  ) => void | Promise<void> | { stop?: boolean } | Promise<{ stop?: boolean }>,
>(
  nodes: Node[],
  callback: Callback
): ReturnType<Callback> extends Promise<any>
  ? Promise<undefined>
  : undefined => {
  let isPromise = false
  const promises = nodes.map((node: Node) => {
    const promiseOrVoid = callback(node)
    if (promiseOrVoid instanceof Promise) {
      isPromise = true
      return promiseOrVoid.then(async (result) => {
        if (result?.stop) return
        if (node.content) {
          await recursivelyProcessTipTapNodes(node.content as Node[], callback)
        }
      })
    } else {
      if (promiseOrVoid?.stop) return
      if (node.content) {
        recursivelyProcessTipTapNodes(node.content as Node[], callback)
      }
    }
  })
  if (isPromise) {
    return Promise.all(promises).then(() => undefined) as any
  }
  return undefined as any
}

export function extractTextFromNode(
  node?: Node,
  opts?: {
    prefix?: string | ((node: Node) => string)
    sufix?: string | ((node: Node) => string)
  }
) {
  let textContent = `${
    opts?.prefix && node
      ? typeof opts.prefix === 'function'
        ? opts.prefix(node)
        : opts.prefix
      : ''
  }`

  node?.content?.forEach((child) => {
    if (child.type === 'text' && 'text' in child) {
      textContent += child.text
    }
    if ('content' in child && child.content) {
      textContent += extractTextFromNode(child, opts)
    }
  })

  return `${textContent}${
    opts?.sufix && node
      ? typeof opts.sufix === 'function'
        ? opts.sufix(node)
        : opts.sufix
      : ''
  }`
}

export function slugifyHeadings__MUTATES(node?: Node) {
  const slugger = new GithubSlugger() // important. `enhanceGeneratedHTML` uses this slugger and it needs to match.
  recursivelyProcessTipTapNodes(node?.content ?? [], (node) => {
    if (node.type === 'heading') {
      const id = slugger.slug(extractTextFromNode(node))
      node.attrs = {
        ...node.attrs,
        id,
      }
    }
  })
  return node
}
